import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 151,
	height: 46,
	viewBox: "0 0 102 31",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Play",
		clipPath: "url(#clip0_13543_52506)",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 101.25,
			height: 30,
			transform: "translate(0.262695 0.151367)",
			fill: "white"
		}), /* @__PURE__ */ _jsxs("g", {
			id: "g10",
			children: [/* @__PURE__ */ _jsx("g", {
				id: "g12",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "Clip path group",
					children: [/* @__PURE__ */ _jsx("mask", {
						id: "mask0_13543_52506",
						style: { maskType: "luminance" },
						maskUnits: "userSpaceOnUse",
						x: 0,
						y: 0,
						width: 102,
						height: 31,
						children: /* @__PURE__ */ _jsx("g", {
							id: "clipPath18",
							children: /* @__PURE__ */ _jsx("path", {
								id: "path16",
								d: "M0.262695 0.151524H101.512V30.1514H0.262695V0.151524Z",
								fill: "white"
							})
						})
					}), /* @__PURE__ */ _jsx("g", {
						mask: "url(#mask0_13543_52506)",
						children: /* @__PURE__ */ _jsxs("g", {
							id: "g14",
							children: [
								/* @__PURE__ */ _jsx("path", {
									id: "path20",
									d: "M97.7624 30.1514H4.01267C1.95021 30.1514 0.262695 28.464 0.262695 26.4013V3.90149C0.262695 1.83888 1.95021 0.151493 4.01267 0.151493H97.7624C99.8249 0.151493 101.512 1.83888 101.512 3.90149V26.4013C101.512 28.464 99.8249 30.1514 97.7624 30.1514Z",
									fill: "#100F0D"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "path22",
									d: "M97.7624 0.151524H4.01267C1.95021 0.151524 0.262695 1.83907 0.262695 3.90153V26.4014C0.262695 28.464 1.95021 30.1514 4.01267 30.1514H97.7624C99.8249 30.1514 101.512 28.464 101.512 26.4014V3.90153C101.512 1.83907 99.8249 0.151524 97.7624 0.151524ZM97.7624 0.751499C99.4995 0.751499 100.912 2.16445 100.912 3.90153V26.4014C100.912 28.1384 99.4995 29.5514 97.7624 29.5514H4.01267C2.27568 29.5514 0.862691 28.1384 0.862691 26.4014V3.90153C0.862691 2.16445 2.27568 0.751499 4.01267 0.751499H97.7624Z",
									fill: "#A2A2A1"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "path24",
									d: "M80.4643 22.6521H81.8638V13.2763H80.4643V22.6521ZM93.0694 16.6536L91.4653 20.7184H91.4172L89.7522 16.6536H88.2447L90.7415 22.3347L89.318 25.4952H90.7775L94.6256 16.6536H93.0694ZM85.1329 21.5869C84.674 21.5869 84.035 21.3574 84.035 20.7906C84.035 20.0667 84.8308 19.7899 85.5185 19.7899C86.1335 19.7899 86.423 19.9227 86.7973 20.1034C86.6885 20.972 85.9407 21.5869 85.1329 21.5869ZM85.3017 16.4487C84.2885 16.4487 83.2385 16.8949 82.8042 17.8834L84.0469 18.4025C84.3124 17.8834 84.8068 17.7148 85.3257 17.7148C86.0495 17.7148 86.7852 18.149 86.7973 18.9207V19.0174C86.5437 18.8727 86.0008 18.656 85.3378 18.656C83.999 18.656 82.6355 19.3917 82.6355 20.7666C82.6355 22.0212 83.7335 22.829 84.9635 22.829C85.9047 22.829 86.423 22.4074 86.7493 21.9124H86.7973V22.6362H88.148V19.0415C88.148 17.3772 86.9061 16.4487 85.3017 16.4487ZM76.6527 17.795H74.6622V14.5804H76.6527C77.6991 14.5804 78.2929 15.4475 78.2929 16.1877C78.2929 16.9145 77.6991 17.795 76.6527 17.795ZM76.6168 13.2763H73.2635V22.6521H74.6622V19.1H76.6168C78.1677 19.1 79.6926 17.9764 79.6926 16.1877C79.6926 14.399 78.1677 13.2763 76.6168 13.2763ZM58.3311 21.5885C57.3643 21.5885 56.5551 20.7792 56.5551 19.6677C56.5551 18.5442 57.3643 17.7222 58.3311 17.7222C59.2857 17.7222 60.0343 18.5442 60.0343 19.6677C60.0343 20.7792 59.2857 21.5885 58.3311 21.5885ZM59.9376 17.1785H59.8896C59.5754 16.8042 58.9715 16.4652 58.2104 16.4652C56.615 16.4652 55.1533 17.867 55.1533 19.6677C55.1533 21.4557 56.615 22.8455 58.2104 22.8455C58.9715 22.8455 59.5754 22.5072 59.8896 22.1203H59.9376V22.5792C59.9376 23.8001 59.2857 24.452 58.2344 24.452C57.3764 24.452 56.8446 23.8361 56.6271 23.3164L55.4069 23.8243C55.757 24.6701 56.6879 25.709 58.2344 25.709C59.8776 25.709 61.2673 24.7423 61.2673 22.3864V16.6587H59.9376V17.1785ZM62.2333 22.6521H63.6351V13.2755H62.2333V22.6521ZM65.7013 19.5589C65.6652 18.3259 66.6561 17.6982 67.3685 17.6982C67.925 17.6982 68.396 17.9758 68.5527 18.3748L65.7013 19.5589ZM70.0513 18.4955C69.785 17.7822 68.9758 16.4652 67.3205 16.4652C65.6773 16.4652 64.3123 17.7582 64.3123 19.6558C64.3123 21.4438 65.6652 22.8455 67.4772 22.8455C68.9397 22.8455 69.785 21.9514 70.1361 21.4318L69.0485 20.7065C68.6855 21.2382 68.1905 21.5885 67.4772 21.5885C66.7647 21.5885 66.2571 21.2623 65.9308 20.6225L70.1961 18.8577L70.0513 18.4955ZM36.0704 17.4448V18.7977H39.3082C39.2113 19.5589 38.9579 20.1147 38.5715 20.5009C38.0999 20.9726 37.3626 21.4918 36.0704 21.4918C34.0761 21.4918 32.5176 19.8852 32.5176 17.891C32.5176 15.8975 34.0761 14.291 36.0704 14.291C37.1459 14.291 37.9311 14.7132 38.5109 15.2569L39.4655 14.303C38.6555 13.5297 37.5808 12.9373 36.0704 12.9373C33.3396 12.9373 31.0439 15.161 31.0439 17.891C31.0439 20.6225 33.3396 22.8455 36.0704 22.8455C37.5441 22.8455 38.6555 22.3616 39.5256 21.4557C40.4196 20.5617 40.6978 19.3055 40.6978 18.29C40.6978 17.9758 40.6738 17.6863 40.6251 17.4448H36.0704ZM44.3788 21.5885C43.4129 21.5885 42.5789 20.7912 42.5789 19.6558C42.5789 18.5074 43.4129 17.7222 44.3788 17.7222C45.3455 17.7222 46.1795 18.5074 46.1795 19.6558C46.1795 20.7912 45.3455 21.5885 44.3788 21.5885ZM44.3788 16.4652C42.6148 16.4652 41.1771 17.807 41.1771 19.6558C41.1771 21.4918 42.6148 22.8455 44.3788 22.8455C46.1429 22.8455 47.5814 21.4918 47.5814 19.6558C47.5814 17.807 46.1429 16.4652 44.3788 16.4652ZM51.3643 21.5885C50.3975 21.5885 49.5636 20.7912 49.5636 19.6558C49.5636 18.5074 50.3975 17.7222 51.3643 17.7222C52.3312 17.7222 53.1644 18.5074 53.1644 19.6558C53.1644 20.7912 52.3312 21.5885 51.3643 21.5885ZM51.3643 16.4652C49.6004 16.4652 48.1625 17.807 48.1625 19.6558C48.1625 21.4918 49.6004 22.8455 51.3643 22.8455C53.1283 22.8455 54.566 21.4918 54.566 19.6558C54.566 17.807 53.1283 16.4652 51.3643 16.4652Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "path26",
									d: "M15.8006 14.7191L7.81543 23.1942C7.81617 23.1956 7.81617 23.1979 7.8169 23.1993C8.06216 24.1196 8.90216 24.7969 9.89967 24.7969C10.2987 24.7969 10.6729 24.6889 10.9939 24.4999L11.0194 24.4848L20.0074 19.2987L15.8006 14.7191Z",
									fill: "#EB3131"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "path28",
									d: "M23.8788 13.2762L23.8714 13.2708L19.9909 11.0215L15.6191 14.9118L20.0065 19.2979L23.8661 17.0711C24.5425 16.7052 25.0024 15.9919 25.0024 15.1698C25.0024 14.3523 24.5493 13.6429 23.8788 13.2762Z",
									fill: "#F6B60B"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "path30",
									d: "M7.81565 7.10908C7.76766 7.28603 7.74219 7.47207 7.74219 7.66407V22.6401C7.74219 22.8321 7.76766 23.018 7.81645 23.1943L16.0754 14.936L7.81565 7.10908Z",
									fill: "#5778C5"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "path32",
									d: "M15.8599 15.1514L19.9924 11.0196L11.0149 5.8146C10.6887 5.61884 10.3077 5.50631 9.90042 5.50631C8.90289 5.50631 8.06144 6.18512 7.81617 7.10609C7.81617 7.10687 7.81543 7.10765 7.81543 7.10844L15.8599 15.1514Z",
									fill: "#3BAD49"
								})
							]
						})
					})]
				})
			}), /* @__PURE__ */ _jsx("g", {
				id: "g34",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "Clip path group_2",
					children: [/* @__PURE__ */ _jsx("mask", {
						id: "mask1_13543_52506",
						style: { maskType: "luminance" },
						maskUnits: "userSpaceOnUse",
						x: 0,
						y: 0,
						width: 102,
						height: 31,
						children: /* @__PURE__ */ _jsx("g", {
							id: "clipPath40",
							children: /* @__PURE__ */ _jsx("path", {
								id: "path38",
								d: "M0.262695 0.151367H101.512V30.1514H0.262695V0.151367Z",
								fill: "white"
							})
						})
					}), /* @__PURE__ */ _jsx("g", {
						mask: "url(#mask1_13543_52506)",
						children: /* @__PURE__ */ _jsxs("g", {
							id: "g36",
							children: [
								/* @__PURE__ */ _jsx("path", {
									id: "path42",
									d: "M31.6006 5.3302H32.3183V9.3233H34.3281V10.002H31.6006V5.3302Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "path44",
									d: "M37.7539 8.13589L37.2318 6.7035L37.0557 6.16857H37.0165L36.8403 6.7035L36.3184 8.13589H37.7539ZM36.6251 5.3302H37.4406L39.2089 10.002H38.4194L37.9887 8.80137H36.0834L35.6529 10.002H34.8633L36.6251 5.3302Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "path46",
									d: "M40.2006 9.76712C39.8918 9.54111 39.6765 9.22341 39.5547 8.81449L40.2332 8.54052C40.3029 8.80148 40.4269 9.01464 40.6051 9.17999C40.7835 9.34535 40.9988 9.42795 41.2512 9.42795C41.486 9.42795 41.6852 9.36698 41.8482 9.2452C42.0113 9.12357 42.093 8.95587 42.093 8.74271C42.093 8.54695 42.0212 8.38504 41.8776 8.25668C41.7341 8.12831 41.486 8.00324 41.1336 7.88146L40.8401 7.77707C40.5225 7.66391 40.2583 7.5064 40.0473 7.30405C39.8363 7.10171 39.7309 6.83323 39.7309 6.49829C39.7309 6.26773 39.7929 6.05457 39.9169 5.85882C40.0409 5.66305 40.2147 5.50852 40.4388 5.39551C40.663 5.28235 40.9162 5.22593 41.199 5.22593C41.6035 5.22593 41.9276 5.32467 42.1713 5.52262C42.4148 5.72073 42.5801 5.94361 42.6673 6.19156L42.0212 6.46553C41.9776 6.30895 41.8863 6.17416 41.7471 6.061C41.6079 5.948 41.4273 5.89142 41.2054 5.89142C40.9924 5.89142 40.8118 5.948 40.6639 6.061C40.5161 6.17416 40.4421 6.31773 40.4421 6.4917C40.4421 6.65267 40.5084 6.78652 40.6412 6.89294C40.7738 6.99952 40.9792 7.10077 41.2576 7.19638L41.5577 7.30076C41.958 7.43994 42.2668 7.6205 42.4845 7.84228C42.7019 8.06421 42.8107 8.36012 42.8107 8.7297C42.8107 9.03423 42.7334 9.28987 42.579 9.49644C42.4246 9.70301 42.2267 9.85646 41.9853 9.95645C41.7438 10.0564 41.4969 10.1064 41.2446 10.1064C40.8575 10.1064 40.5095 9.99328 40.2006 9.76712Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "path48",
									d: "M44.6641 6.0087H43.3525V5.3302H46.6867V6.0087H45.3818V10.002H44.6641V6.0087Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "path50",
									d: "M48.9053 5.3302H49.7537L51.8677 8.76219H51.9069L51.8677 7.86176V5.3302H52.5789V10.002H51.8351L49.6167 6.39364H49.5775L49.6167 7.29407V10.002H48.9053V5.3302Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "path52",
									d: "M53.7656 5.3302H56.5975V6.0087H54.4833V7.32683H56.3886V8.00533H54.4833V9.3233H56.5975V10.002H53.7656V5.3302Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "path54",
									d: "M59.0771 9.3233C59.6079 9.3233 60.02 9.1766 60.3136 8.88303C60.6073 8.58932 60.754 8.18385 60.754 7.666C60.754 7.14847 60.6073 6.74268 60.3136 6.44912C60.02 6.1554 59.6079 6.0087 59.0771 6.0087H58.3202V9.3233H59.0771ZM57.6025 5.3302H59.0967C59.5796 5.3302 60.0004 5.428 60.3593 5.62376C60.7182 5.81952 60.9942 6.09475 61.188 6.44912C61.3815 6.80381 61.4782 7.20928 61.4782 7.666C61.4782 8.12272 61.3815 8.5285 61.188 8.88303C60.9942 9.23756 60.7182 9.51263 60.3593 9.70839C60.0004 9.90415 59.5796 10.002 59.0967 10.002H57.6025V5.3302Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "path56",
									d: "M65.4452 7.50942C65.6843 7.50942 65.8768 7.43435 66.0226 7.28435C66.1683 7.1342 66.2412 6.95913 66.2412 6.75914C66.2412 6.55915 66.1683 6.38392 66.0226 6.23377C65.8768 6.08378 65.6843 6.0087 65.4452 6.0087H64.5382V7.50942H65.4452ZM63.8203 5.3302H65.4256C65.7039 5.3302 65.9594 5.39101 66.1922 5.5128C66.4249 5.63458 66.6097 5.80432 66.7468 6.02187C66.8838 6.23925 66.9525 6.48501 66.9525 6.75914C66.9525 7.03311 66.8838 7.27887 66.7468 7.49641C66.6097 7.71396 66.4249 7.8837 66.1922 8.00533C65.9594 8.12711 65.7039 8.18808 65.4256 8.18808H64.5382V10.002H63.8203V5.3302Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "path58",
									d: "M68.9878 4.87662C68.9356 4.93116 68.9096 4.99526 68.9096 5.06924C68.9096 5.14306 68.9356 5.20732 68.9878 5.26155C69.04 5.3161 69.1031 5.34321 69.1771 5.34321C69.2511 5.34321 69.3152 5.3161 69.3696 5.26155C69.4238 5.20732 69.4511 5.14306 69.4511 5.06924C69.4511 4.99526 69.4238 4.93116 69.3696 4.87662C69.3152 4.82223 69.2511 4.79496 69.1771 4.79496C69.1031 4.79496 69.04 4.82223 68.9878 4.87662ZM69.8948 8.13589L69.3793 6.70695L69.1967 6.17186H69.1575L68.9814 6.70695L68.4659 8.13589H69.8948ZM71.3499 10.002H70.5669L70.1297 8.80137H68.2309L67.8004 10.002H67.0107L68.6616 5.62376C68.5832 5.55417 68.5234 5.47158 68.4823 5.37581C68.4408 5.28005 68.4202 5.17786 68.4202 5.06924C68.4202 4.85593 68.493 4.67662 68.6389 4.53086C68.7845 4.3851 68.964 4.31222 69.1771 4.31222C69.3859 4.31222 69.5653 4.3862 69.7155 4.53415C69.8655 4.68195 69.9404 4.86016 69.9404 5.06924C69.9404 5.28663 69.86 5.47157 69.699 5.62376L71.3499 10.002Z",
									fill: "white"
								})
							]
						})
					})]
				})
			})]
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_13543_52506",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 101.25,
			height: 30,
			fill: "white",
			transform: "translate(0.262695 0.151367)"
		})
	}) })]
});
export default SvgPlay;
